import { IClassAndFeeStructureSchemaResponse } from '../../apis/institute/institute.interfaces';
import { TStudentDetails } from '../../apis/students/students.interfaces';

export const mockGradeAndFeeStructure: IClassAndFeeStructureSchemaResponse = {
  classes: [
    {
      classId: 'GRADE_1',
      className: 'GRADE_1' as any,
      classDescription: 'Grade 1 standard',
      sections: [
        { sectionId: 'SECTION_A', label: 'A' },
        { sectionId: 'SECTION_B', label: 'B' },
      ],
      categories: [
        {
          categoryId: 'REGULAR',
          category: 'Regular',
          categoryDescription: 'Regular fee plan',
          feeComponents: [
            {
              feeId: 'TUITION',
              feeType: 'Tuition Fee',
              feeAmount: 50000,
              feeDescription: 'Annual tuition fee',
            },
            {
              feeId: 'TRANSPORT',
              feeType: 'Transport Fee',
              feeAmount: 12000,
              feeDescription: 'Annual transport fee',
            },
            {
              feeId: 'MISC',
              feeType: 'Miscellaneous',
              feeAmount: 8000,
              feeDescription: 'Miscellaneous charges',
            },
          ],
          requiredDocuments: [],
        },
      ],
    },
  ],
};

export const mockStudentWithFeeDetails: Partial<TStudentDetails> = {
  grade: 'GRADE_1' as any,
  category: 'REGULAR' as any,
  feeDetails: {
    studentId: 'STU_001',
    userId: 'USER_001',
    instituteId: 'INST_001',
    feeComponentId: 'fee_plan_regular',
    feePaymentSchedule: 'annual' as any,
    feeComponents: [
      {
        id: 'fee_txn_1',
        description: 'Tuition Fee for the academic year 2025-2026',
        status: 'partial' as any,
        componentId: 'TUITION',
        amount: 50000,
        paidAmount: 10000,
        componentName: 'Tuition Fee',
        dueDate: '2025-12-15T00:00:00.000Z' as any,
        academicYear: 2025,
        purpose: 'fee_tuition',
        instituteRef: 'INST_001',
        createdBy: 'ADMIN_001',
      },
      {
        id: 'fee_txn_2',
        description: 'Transport Fee for the academic year 2025-2026',
        status: 'unpaid' as any,
        componentId: 'TRANSPORT',
        amount: 12000,
        paidAmount: 6000,
        componentName: 'Transport Fee',
        dueDate: '2025-12-20T00:00:00.000Z' as any,
        academicYear: 2025,
        purpose: 'fee_transport',
        instituteRef: 'INST_001',
        createdBy: 'ADMIN_001',
      },
      {
        id: 'fee_txn_3',
        description: 'Miscellaneous charges for the academic year 2025-2026',
        status: 'unpaid' as any,
        componentId: 'MISC',
        amount: 8000,
        paidAmount: 0,
        componentName: 'Miscellaneous',
        dueDate: '2025-12-31T00:00:00.000Z' as any,
        academicYear: 2025,
        purpose: 'fee_miscellaneous',
        instituteRef: 'INST_001',
        createdBy: 'ADMIN_001',
      },
    ],
    createdBy: 'ADMIN_001',
  } as any,
};
